<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{ $t('objects.details.title') }} - {{rmsobject.name}}</div>
                    <div class="card-body">
                        <kendo-tabstrip :selected="selected" @select="onSelect" :tabs="tabs">

                            <template v-slot:details>
                                <rms-objects-detail-tab :rmsobject='rmsobject' style="min-width:1400px"></rms-objects-detail-tab>
                            </template>

                            <!--
                            <template v-slot:details>
                                <rms-objects-service-tab :rmsobject='rmsobject'></rms-objects-service-tab>
                            </template>
                            -->

                            <template v-slot:history>
                                <rms-objects-history-tab :rmsobjectid='rmsobjectid' style="min-width:1400px"></rms-objects-history-tab>
                            </template>

                            <template v-slot:orders>
                                <rms-objects-orders-tab :rmsobjectid='rmsobjectid' style="min-width:1400px"></rms-objects-orders-tab>
                            </template>

                        </kendo-tabstrip>
                    </div>
            </div>
            <div class="form-group row h-auto pb-5">
            <div class="col-md-6 offset-md-10">
                <button type="submit" class="btn btn-secondary"
                        @click.prevent="handleBack('objects-grid', true, {reload: false, id: rmsobjectid})">
                    {{ $t('buttons.back') }}
                </button>
                <button type="submit" class="btn btn-primary"
                        v-shortkey.once="['e']" @shortkey="editAction"
                        @click.prevent="editAction">
                    {{ $t('buttons.edit') }}
                </button>
                <button type="submit" class="btn btn-danger"
                        @click.prevent="deleteAction">
                    {{ $t('buttons.delete') }}
                </button>

            </div>
        </div>
    </div>
        </div>
    </div>
</template>

<script>
    import RmsObjectsDetailTab from "./rms-objects-detail-tab";
    import RmsObjectsServiceTab from "./rms-objects-service-tab";
    import RmsObjectsHistoryTab from "./rms-objects-history-tab";
    import RmsObjectsOrdersTab from "./rms-objects-orders-tab";
    export default {
        name: "rms-objects-detail",
        components: {RmsObjectsHistoryTab, RmsObjectsServiceTab, RmsObjectsDetailTab, RmsObjectsOrdersTab},
        props: ['user', 'rmsobjectid'],
        data: function () {
            return {
                rmsobject: {},
                selected: 0,
                tabs: [
                    {
                        title: this.$t('objects.details.details'),
                        content: 'details',
                    },
                    {
                        title: this.$t('objects.details.change-protocol'),
                        content: 'history',
                    },
                    {
                        title: this.$t('objects.details.orders'),
                        content: 'orders',
                    },
                ],
            }
        },
        mounted() {
            this.init();
        },

        methods: {
            init: function () {
                // Laden eines RMS-Objektes
                if (this.rmsobjectid) {
                    axios
                        .get('/api/rmsobjects/id/' + this.rmsobjectid)
                        .then(response => {
                            this.rmsobject = response.data;
                            console.log(this.rmsobject);
                        })
                        .catch(error => {
                            console.log("err", error);
                        })
                        .finally(() => {
                        })
                }

            },
            onSelect: function (e) {
                this.selected = e.selected;
            },
            editAction: function () {
                console.log("edit action", this.rmsobjectid);
                const rmsobjectid = this.rmsobjectid;
                this.$router.push({ name: 'objects-edit', params: { rmsobjectid } })
            },
            deleteAction: function () {
                console.log("delete action", this.rmsobjectid);
                swal.fire({
                    title: this.$t('objects.grid.delete-popup-title'),
                    text: this.$t('objects.grid.delete-popup-text'),
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: this.$t('general.cancel'),
                    confirmButtonText: this.$t('general.ok'),
                }).then((willDelete) => {
                    if (willDelete.value) {
                        axios.delete('/api/rmsobjects/delete/' + this.rmsobjectid)
                            .then(response => {
                                console.log("rmsobjects/delete response", response);
                                swal.fire({
                                    text: this.$t('objects.grid.delete-popup-deleted'),
                                    icon: "success",
                                    timer: 2000
                                }).then(response =>{
                                    this.handleBack('objects-grid', true, {reload: true})
                                });
                            });
                    } else {
                        return;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
